import { render } from "./FormCambiarPass.vue?vue&type=template&id=78648b80"
import script from "./FormCambiarPass.vue?vue&type=script&lang=js"
export * from "./FormCambiarPass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__